import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  MatSelectionList,
  MatSelectionListChange
} from '@angular/material/list';
import { SiteService } from 'src/app/services/index';
import { AlertService, Constants } from 'src/app/shared/index';

@Component({
  selector: 'app-assign-meter-modal',
  templateUrl: './assign-meter-modal.component.html',
  styleUrls: ['./assign-meter-modal.component.scss']
})
export class AssignMeterModalComponent implements OnInit {
  formdata: UntypedFormGroup;
  @ViewChild(MatSelectionList) meters: MatSelectionList;
  selectedLoad: any;
  availableMeters: any;
  siteId: string;

  mtrToAssign: any;
  searchMtrToAssign = '';

  ratings = [1, 2, 3, 4];
  accuracies = ['1', '2', '3', '4'];
  ctTypes = [
    'Fixed Core',
    'Split Core',
    'Rogowski',
    'IntellCT_A',
    'IntellCT_B'
  ];
  meterToLoadData: any;
  constructor(
    public dialogRef: MatDialogRef<AssignMeterModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private siteService: SiteService,
    private alertService: AlertService
  ) {
    this.selectedLoad = data.selectedLoad;
    this.availableMeters = data.availableMeters;
    this.siteId = data.siteId;
  }

  ngOnInit() {
    const t = this;

    t.formdata = t.fb.group({
      inputSearchCtr: [],
      assignMtrCtr: ['', [Validators.required]],
      ctTypeCtr: ['', [Validators.required]],
      ratingCtr: [],
      accuracyCtr: []
    });
    this.meters.selectionChange.subscribe((s: MatSelectionListChange) => {
      this.meters.deselectAll();
      s.options[0].selected = true;
    });
  }
  public onAssignMtrChanged = (meters: any) => {
    const temp = meters.selectedOptions.selected.map((item: any) => {
      return item.value;
    });
    this.mtrToAssign = temp[0];
  };
  assingMeterToLoad() {
    this.meterToLoadData = {
      siteId: this.siteId,
      // meterRId: this.mtrToAssign.rId, // use meterId
      meterId: this.mtrToAssign.meterId,
      loadId: this.selectedLoad.loadId
    };
    this.siteService.mapMeterToLoad(this.meterToLoadData).subscribe((data) => {
      if (data.result === Constants.SUCCESS) {
        const loadData = {
          // use meterId
          meterId: this.meterToLoadData.meterId,
          ctType: this.selectedLoad.meter.ctMake,
          ctRating: this.selectedLoad.meter.ctRatingPrimary,
          ctAccuracy: this.selectedLoad.meter.ctAccuracy
        };

        this.mtrToAssign.ctMake = this.selectedLoad.meter.ctMake;
        this.mtrToAssign.ctRatingPrimary =
          this.selectedLoad.meter.ctRatingPrimary;
        this.mtrToAssign.ctAccuracy = this.selectedLoad.meter.ctAccuracy;
        this.selectedLoad.meter = this.mtrToAssign;
        this.alertService.showSuccess(Constants.MESSAGE.Save_success);
        this.dialogRef.close({ status: true, data: [loadData] });
      } else {
        this.alertService.showError(data.message);
      }
    });
  }

  close(confirm: boolean) {
    this.dialogRef.close({ status: confirm, data: null });
  }
}
